// Атрибут data-test-id для автотестов - правила в .project-brain/conventions.md#data-test-id.
// Переиспользуемый компонент строит id своих элементов от id, который ему передал родитель
// (атрибут без prop'а попадает в $attrs и на корень компонента):
// <Modal data-test-id="clients-view__popup-filter-modal"> -> кнопка закрытия "clients-view__popup-filter-modal__close-btn".
// Родитель не передал id - берётся имя компонента по умолчанию (fallback).
// Без element - id самого компонента: нужен, когда корень компонента - другой наш компонент
// (<Modal :data-test-id="$tid('modal-create-app')">), иначе id от родителя до вложенного не дойдёт.
export function childTestId(attrs: Record<string, unknown>, fallback: string, element?: string): string {
  const parentId = attrs['data-test-id'];
  const base = typeof parentId === 'string' && parentId ? parentId : fallback;
  return element ? `${base}__${element}` : base;
}
